module.exports = __webpack_public_path__ + "img/_blog8.50f0f640.jpg";